import dayjs from "dayjs";

import { FaEye } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";

import { Paginated } from "@/@types/generics/paginated";
import { ActiveTeenVaccination } from "@/@types/esus/ActiveTeenVaccination";

import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";
import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	activeTeenVaccinationData: Paginated<ActiveTeenVaccination>;
	isLoading: boolean;
	handleOpenCitizenActiveVaccinations: (
		selectedCitizenActiveTeenVaccination: ActiveTeenVaccination
	) => void;
};

export function TableActiveTeenVaccinationSearch({
	activeTeenVaccinationData,
	isLoading,
	handleOpenCitizenActiveVaccinations,
}: Readonly<Props>) {
	return (
		<div>
			<Table className="bg-white" responsive striped bordered hover>
				<thead className="fw-bolder text-muted">
					<tr>
						<th className="text-center">NOME</th>
						<th className="text-center">CPF</th>
						<th className="text-center">CNS</th>
						<th className="text-center">DN</th>
						<th className="text-center text-nowrap">
							<label className="me-2">Nº DE PENDÊCIAS</label>
							<CardOverlayTrigger message="Nº de pendências vacinais" />
						</th>
						<th className="text-center">AÇÕES</th>
					</tr>
				</thead>
				<tbody>
					{activeTeenVaccinationData?.data && !isLoading ? (
						activeTeenVaccinationData.data?.map((item, index) => (
							<tr key={index + 1}>
								<td title="Nome" className="align-content-center text-nowrap ps-2">
									{item.fullName ?? "NÃO INFORMADO"}
								</td>
								<td className="text-center align-content-center ps-2">
									{item.identifier}
								</td>
								<td className="text-center align-content-center ps-2">
									{item.cns}
								</td>
								<td className="text-center align-content-center ps-2">
									{item.birthdate
										? dayjs(item.birthdate).format("DD/MM/YYYY")
										: "NÃO INFORMADO"}
								</td>
								<td className="align-content-center text-center">
									{item.countRegisters}
								</td>
								<td className="align-content-center text-center">
									<Button
										className="bg-primary py-1 px-3"
										onClick={() => {
											handleOpenCitizenActiveVaccinations(item);
										}}
									>
										<FaEye className="fs-4" />
									</Button>
								</td>
							</tr>
						))
					) : (
						<TableSkeletons numberOfCells={6} />
					)}
				</tbody>
			</Table>
		</div>
	);
}
